import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import {
    Button,
    ButtonGroup,
    CardBody,
    CardContent,
    CardV2,
    Col,
    Container,
    InputControl,
    LoaderMi,
    ModalV2,
    ModalV2Content,
    ModalV2Footer,
    ModalV2Title,
    Row,
} from '@design-system-etat/dsfr-react';
import { useHistory } from 'react-router-dom';
import usagerClientReducer from '../../../../../store/usagerReducer';
import {
    API_GET_EDITER_CEAF,
    API_GET_RECHERCHE_ARMES,
    API_POST_CEAF_CREER,
    CONTEXT_CEAF_CREER,
    CONTEXT_CEAF_GENERATION_PDF,
    CONTEXT_EDITER_CEAF,
    CONTEXT_GET_RECHERCHE_ARMES,
} from '../../../../../constants/apiUrls.constants';
import InformationsPersonnelles from '../../../../../components/Ceaf/InformationsPersonnelles/InformationsPersonnelles';
import InformationAdresse from '../../../../../components/adresse/InformationsAdresse';
import PhotoIdentite from '../../../../../components/PhotoIdentite/Editer/PhotoIdentite';
import { getArrayFilesToSend } from '../../../../../utils/fileFunction';
import FileUploadeBack from '../../../../../components/form/InputFiles/Model/FileUploadeBack';
import RoutesMesTitresDeDetention from '../../../mes-titres-de-detention/routes';
import RoutesMesDemarches from '../../routes';
import Crop from '../../../../../components/Crop/Crop';
import styles from './EditerCeaf.module.scss';
import { getPath } from '../../../../../utils/router';
import TableauCeaf from './TableauCeaf';
import AffichageResponsive from '../../../../../components/Commun/AffichageResponsive';
import CarteMobileCEAF from './CarteMobileCEAF';
import InfoChampsObligatoire from '../../../../../components/form/infoObligatoire/InfoChampsObligatoire';
import {
    LIBELLE_DETENUE,
    setTableauStatutsArmes,
} from '../../../../../components/arme/statuts/StatutsArmes';
import { CEAF } from '../../../../../constants/accessibilite.constants';

const EditerCeaf = ({
    reinitialiseApi,
    getApi,
    postApi,
    dataCeaf,
    erreurDataCeaf,
    isLoadingCeaf,
    creerCeafUuid,
    erreurCreerCeaf,
    isLoadingCreerCeaf,
    isLoadingCeafPdfBase64,
    isLoadingRechercheArme,
    dataRechercheArmes,
}) => {
    const hookForm = useForm({
        mode: 'onSubmit',
    });
    const history = useHistory();
    const { handleSubmit, setValue, getValues, watch, formState } = hookForm;
    const [armesSelectionnees, setArmesSelectionnees] = useState([]);
    const [photoIdentiteExige, setPhotoIdentiteExige] = useState(false);
    const [dataToDisplay, setDataToDisplay] = useState(null);
    const [afficherModalCeafCree, setAfficherModalCeafCree] = useState(false);
    const [afficherModalCropPhotoIdentite, setAfficherModalCropPhotoIdentite] = useState();
    const [imageACropper, setImageACropper] = useState();
    const [validerCropImage, setValiderCropImage] = useState(false);

    const isGenerateCeafButtonDisabled = () => {
        return (
            !getValues('photoIdentite') ||
            photoIdentiteExige ||
            creerCeafUuid ||
            !armesSelectionnees.length > 0
        );
    };

    const redirigerVersTitreDetention = () => {
        history.push(getPath(RoutesMesTitresDeDetention));
    };

    useEffect(() => {
        reinitialiseApi(CONTEXT_CEAF_CREER);
        reinitialiseApi(CONTEXT_CEAF_GENERATION_PDF);
        reinitialiseApi(CONTEXT_EDITER_CEAF);
        getApi(usagerClientReducer, API_GET_EDITER_CEAF, CONTEXT_EDITER_CEAF);

        return () => {
            reinitialiseApi(CONTEXT_CEAF_CREER);
            reinitialiseApi(CONTEXT_CEAF_GENERATION_PDF);
            reinitialiseApi(CONTEXT_EDITER_CEAF);
        };
    }, []);

    useEffect(() => {
        if (!erreurCreerCeaf && isLoadingCreerCeaf === false && creerCeafUuid) {
            setAfficherModalCeafCree(true);
            reinitialiseApi(CONTEXT_CEAF_CREER);
        }
    }, [isLoadingCreerCeaf, erreurCreerCeaf]);

    const formaterPhotoIdentite = async (dataPhoto) => {
        return {
            photoIdentite: await getArrayFilesToSend(dataPhoto),
        };
    };

    useEffect(() => {
        if (dataCeaf && isLoadingCeaf === false) {
            if (watch('photoIdentite') && watch('photoIdentite').length === 0) {
                setPhotoIdentiteExige(true);
            } else {
                setPhotoIdentiteExige(false);
            }
        }

        if (
            dataCeaf &&
            watch('photoIdentite')[0] &&
            !watch('photoIdentite')[0].uuid &&
            getValues('photoIdentite') &&
            getValues('photoIdentite').length > 0
        ) {
            formaterPhotoIdentite(getValues('photoIdentite')).then((dataPhotoFormatee) => {
                setAfficherModalCropPhotoIdentite(true);
                setImageACropper(dataPhotoFormatee.photoIdentite[0].contenu);
            });
        }

        if (getValues('photoIdentite') && getValues('photoIdentite').length === 0) {
            setDataToDisplay(null);
            setImageACropper(null);
        }
    }, [watch('photoIdentite')]);

    useEffect(() => {
        if (!dataCeaf) {
            reinitialiseApi(CONTEXT_CEAF_GENERATION_PDF);
            setAfficherModalCeafCree(false);
        }
    }, [dataCeaf]);

    useEffect(() => {
        if (!isLoadingCeaf && dataCeaf) {
            if (
                dataCeaf.personnePhysique &&
                dataCeaf.personnePhysique.ceaf &&
                dataCeaf.personnePhysique.ceaf.photoIdentite
            ) {
                setValue('photoIdentite', [
                    new FileUploadeBack({
                        uuid: dataCeaf.personnePhysique.ceaf.photoIdentite.uuid,
                        filename: dataCeaf.personnePhysique.ceaf.photoIdentite.libelle,
                    }),
                ]);
                setDataToDisplay({
                    uuid: dataCeaf.personnePhysique.ceaf.photoIdentite.uuid,
                    filename: dataCeaf.personnePhysique.ceaf.photoIdentite.libelle,
                });
            }
        }
    }, [isLoadingCeaf, dataCeaf]);

    const annuler = () => {
        history.push(getPath(RoutesMesDemarches));
    };

    const formaterInformations = async () => {
        return {
            listeUuidArme: armesSelectionnees,
            photoIdentite: {
                filename: getValues('photoIdentite')[0].filename,
                contenu: !dataToDisplay.uuid ? dataToDisplay : null,
                uuid: dataToDisplay.uuid ?? null,
            },
        };
    };

    const onSubmit = async (dataForm) => {
        if (dataForm) {
            const dataFormat = await formaterInformations();
            postApi(usagerClientReducer, API_POST_CEAF_CREER, dataFormat, CONTEXT_CEAF_CREER);
        }
    };

    if (erreurDataCeaf) {
        history.push(getPath(RoutesMesDemarches));
    }

    const genererCroppedImage = () => {
        setValiderCropImage(true);
    };

    const recupererImageCroppe = (imageCroppe) => {
        setDataToDisplay(imageCroppe);
        setAfficherModalCropPhotoIdentite(false);
        setImageACropper(null);
        setValiderCropImage(false);
    };

    const closeModal = () => {
        setAfficherModalCropPhotoIdentite(false);
    };

    useEffect(() => {
        getApi(usagerClientReducer, API_GET_RECHERCHE_ARMES, CONTEXT_GET_RECHERCHE_ARMES);
    }, []);

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    const toggleArme = (arme) => {
        setArmesSelectionnees((armesDejaSelectionnees) =>
            armesDejaSelectionnees.includes(arme.uniquid)
                ? armesDejaSelectionnees.filter((a) => a !== arme.uniquid)
                : [...armesDejaSelectionnees, arme.uniquid],
        );
    };

    const [champRecherche, setChampRecherche] = useState('');

    const dataFiltrees = useMemo(() => {
        return (
            dataRechercheArmes && dataRechercheArmes.records
                ? setTableauStatutsArmes(dataRechercheArmes.records, true)
                : []
        ).filter(
            (arme) =>
                (arme.numeroEncodage.toLowerCase().includes(champRecherche) ||
                    arme.numeroCarcasse.toLowerCase().includes(champRecherche) ||
                    arme.type.toLowerCase().includes(champRecherche) ||
                    arme.marque.toLowerCase().includes(champRecherche) ||
                    arme.modele.toLowerCase().includes(champRecherche) ||
                    arme.calibreCanon.toLowerCase().includes(champRecherche) ||
                    (arme.calibreCanonDeux &&
                        arme.calibreCanonDeux.toLowerCase().includes(champRecherche)) ||
                    arme.classement.toLowerCase().includes(champRecherche) ||
                    arme.classementEuropeen.toLowerCase().includes(champRecherche) ||
                    armesSelectionnees.includes(arme.uniquid)) &&
                arme.statut === LIBELLE_DETENUE,
        );
    }, [dataRechercheArmes, champRecherche, armesSelectionnees]);

    return (
        <>
            {afficherModalCropPhotoIdentite && !formState.errors.photoIdentite && (
                <ModalV2
                    id="recadragePhoto"
                    idModalTitle="recadragePhoto-title"
                    size="lg"
                    onClose={closeModal}
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="recadragePhoto-title">
                            Veuillez recadrer votre photo
                        </ModalV2Title>

                        <div style={{ height: '300px' }} className="position-relative">
                            {imageACropper && (
                                <Crop
                                    image={imageACropper}
                                    validerCropImage={validerCropImage}
                                    handleRecupererImageCroppe={recupererImageCroppe}
                                />
                            )}
                        </div>
                    </ModalV2Content>
                    <ModalV2Footer>
                        <ButtonGroup align="right" inline>
                            <Button variant="secondary" onClick={genererCroppedImage}>
                                Valider le recadrage de la photo
                            </Button>
                        </ButtonGroup>
                    </ModalV2Footer>
                </ModalV2>
            )}

            {afficherModalCeafCree && (
                <ModalV2
                    id="ceafGenerer"
                    idModalTitle="ceafGenerer-title"
                    onClose={redirigerVersTitreDetention}
                    size="lg"
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="ceafGenerer-title">
                            <abbr>{CEAF}</abbr> générée
                        </ModalV2Title>

                        <p>
                            Vous pouvez télécharger dès à présent votre <abbr>{CEAF}</abbr> sur
                            l&apos;écran &quot;Mes titres de détention&quot;
                        </p>
                    </ModalV2Content>
                </ModalV2>
            )}

            {(isLoadingCeaf || isLoadingRechercheArme || isLoadingCreerCeaf) && (
                <div className="loader-container">
                    <LoaderMi taille="md" />
                </div>
            )}
            {dataCeaf && (
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <h1>
                            Édition de ma carte européenne d&apos;arme à feu (<abbr>{CEAF}</abbr>)
                        </h1>
                        <h2 className="font-size-md margin0">
                            Récapitulatif des informations personnelles
                        </h2>
                        <InfoChampsObligatoire />
                        <Row gutters isHorizontal className={styles.groupe_cartes}>
                            <Col col={12} xl={4} lg={6} md={6} sm={12} className="margin-bottom-sm">
                                <CardV2 taille="lg" noEnlargeLink>
                                    <CardBody>
                                        <CardContent>
                                            <PhotoIdentite
                                                photoIdentite={dataToDisplay}
                                                titre="Photo d'identité"
                                            />
                                        </CardContent>
                                    </CardBody>
                                </CardV2>
                            </Col>
                            <Col col={12} xl={4} lg={6} md={6} sm={12} className="margin-bottom-sm">
                                <InformationsPersonnelles
                                    personnePhysique={dataCeaf.personnePhysique}
                                    titre="Identité"
                                    afficherBoutonAction
                                />
                            </Col>
                            <Col col={12} xl={4} lg={12} sm={12} className="margin-bottom-sm">
                                <InformationAdresse
                                    adresse={dataCeaf.personnePhysique.adressePrincipale}
                                    titre="Résidence principale"
                                    afficherBoutonAction
                                />
                            </Col>
                        </Row>
                        <Row gutters>
                            <Col col={12}>
                                <h2 className="font-size-md margin0">
                                    Armes que vous souhaitez voir apparaître sur votre carte
                                    européenne d&apos;armes à feu
                                </h2>
                            </Col>
                            <Col col={12}>
                                <h3 className="font-size-sm">
                                    Seules les armes au statut &quot;d&eacute;tenue&quot; dans votre
                                    râtelier numérique peuvent être ajoutées à votre carte
                                    européenne d&apos;arme à feu
                                </h3>
                            </Col>
                            <Col col={12}>
                                <AffichageResponsive
                                    pointDeRupture="xl"
                                    composantDesktop={
                                        <>
                                            <Col col={6}>
                                                <InputControl
                                                    id="filtreArmeCEAF"
                                                    name="filtreArmeCEAF"
                                                    label="Rechercher une arme"
                                                    onChange={(e) => {
                                                        setChampRecherche(
                                                            e.target.value.toLowerCase(),
                                                        );
                                                    }}
                                                />
                                            </Col>
                                            <TableauCeaf
                                                armes={dataFiltrees}
                                                toggleArme={toggleArme}
                                                armesSelectionnees={armesSelectionnees}
                                            />
                                        </>
                                    }
                                    composantMobile={
                                        <>
                                            <Col col={6}>
                                                <InputControl
                                                    id="filtreArmeCEAF"
                                                    name="filtreArmeCEAF"
                                                    label="Rechercher une arme"
                                                    onChange={(e) => {
                                                        setChampRecherche(
                                                            e.target.value.toLowerCase(),
                                                        );
                                                    }}
                                                />
                                            </Col>
                                            <Container>
                                                <Row>
                                                    {dataFiltrees.map((arme) => (
                                                        <CarteMobileCEAF
                                                            armesSelectionnees={armesSelectionnees}
                                                            key={arme.uniquid}
                                                            arme={arme}
                                                            toggleArme={toggleArme}
                                                        />
                                                    ))}
                                                </Row>
                                            </Container>
                                        </>
                                    }
                                />
                            </Col>
                        </Row>

                        <Row gutters>
                            <Col lg={7} />
                            <Col lg={5} className="btn-group-align-right">
                                <Button
                                    icon="fr-fi-close-line"
                                    iconPosition="left"
                                    name="Annuler"
                                    variant="secondary"
                                    onClick={annuler}
                                >
                                    Annuler
                                </Button>
                                <Button
                                    icon="fr-fi-printer-line"
                                    iconPosition="left"
                                    name="genererMaCeaf"
                                    type="submit"
                                    variant="primary"
                                    isLoading={
                                        isLoadingCeaf ||
                                        isLoadingCreerCeaf ||
                                        isLoadingCeafPdfBase64
                                    }
                                    disabled={
                                        isGenerateCeafButtonDisabled() ||
                                        (formState.errors.photoIdentite &&
                                            formState.errors.photoIdentite.message)
                                    }
                                >
                                    <span>
                                        Générer ma <abbr>{CEAF}</abbr>
                                    </span>
                                </Button>
                            </Col>
                        </Row>
                    </form>
                </FormProvider>
            )}
        </>
    );
};

EditerCeaf.propTypes = {
    reinitialiseApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    postApi: PropTypes.func.isRequired,
    dataCeaf: PropTypes.shape({
        personnePhysique: PropTypes.shape({
            nom: PropTypes.string.isRequired,
            nomUsage: PropTypes.string.isRequired,
            prenomUsuel: PropTypes.string.isRequired,
            prenomUn: PropTypes.string.isRequired,
            prenomDeux: PropTypes.string,
            prenomTrois: PropTypes.string,
            prenomQuatre: PropTypes.string,
            sexe: PropTypes.bool.isRequired,
            dateNaissance: PropTypes.string.isRequired,
            lieuNaissance: PropTypes.string.isRequired,
            codePostalNaissance: PropTypes.string.isRequired,
            paysNaissance: PropTypes.string.isRequired,
            nationalite: PropTypes.string.isRequired,
            adressePrincipale: PropTypes.shape({
                adresseId: PropTypes.number.isRequired,
                numeroVoie: PropTypes.string.isRequired,
                extension: PropTypes.string.isRequired,
                libelleVoie: PropTypes.string.isRequired,
                lieuDit: PropTypes.string.isRequired,
                codePostal: PropTypes.string.isRequired,
                ville: PropTypes.string.isRequired,
            }).isRequired,
            ceaf: PropTypes.shape({
                photoIdentite: PropTypes.shape({
                    uuid: PropTypes.string,
                    libelle: PropTypes.string,
                }),
                statut: PropTypes.string.isRequired,
                dateExpiration: PropTypes.string.isRequired,
                numeroCeaf: PropTypes.string.isRequired,
            }),
        }),
        isInscritFiniada: PropTypes.bool,
    }).isRequired,
    isLoadingCeaf: PropTypes.bool,
    erreurDataCeaf: PropTypes.bool,
    creerCeafUuid: PropTypes.string,
    isLoadingCreerCeaf: PropTypes.bool,
    erreurCreerCeaf: PropTypes.bool,
    isLoadingCeafPdfBase64: PropTypes.bool,
    isLoadingRechercheArme: PropTypes.bool,
    dataRechercheArmes: PropTypes.object,
};

export default connect(
    (state) => {
        const {
            data: dataCeaf,
            isLoading: isLoadingCeaf,
            erreur: erreurDataCeaf,
        } = state.ceaf.editer;
        const {
            data: creerCeafUuid,
            isLoading: isLoadingCreerCeaf,
            erreur: erreurCreerCeaf,
        } = state.ceaf.creer;
        const { isLoading: isLoadingCeafPdfBase64 } = state.ceaf.fichierPdfBase64;
        const { isLoading: isLoadingRechercheArme, data: dataRechercheArmes } =
            state.recherche.armes;

        return {
            dataCeaf,
            isLoadingCeaf,
            creerCeafUuid,
            isLoadingCreerCeaf,
            erreurDataCeaf,
            erreurCreerCeaf,
            isLoadingCeafPdfBase64,
            isLoadingRechercheArme,
            dataRechercheArmes,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(EditerCeaf);
